import moment from 'moment';
import { TOOLTIP_LABEL_FORMAT, isAppModule } from '@utils/constants';
const getCauseKey = ({ dimensionName, rootCause }) => `${dimensionName}-${rootCause}`;

export const filterAlerts = (selectedAlert, data) => {
  const { alertsSummary } = data;
  const selectedCause = getCauseKey(selectedAlert);
  const filteredAlerts: any = alertsSummary.filter((alert) => selectedCause === getCauseKey(alert));
  return { ...data, alertsSummary: filteredAlerts };
};

export const buildEventHeatMap = (alerts) => {
  const alertCount = {};
  alerts.forEach((alert) => {
    const day = moment(alert.eventTimeRaw).format('YYYY-MM-DD');
    if (day in alertCount) {
      alertCount[day]++;
    } else {
      alertCount[day] = 1;
    }
  });
  return Object.entries(alertCount);
};

export const formatTimeInfo = ({ from, to }) => {
  return `Based on alert data from ${moment(from).format(TOOLTIP_LABEL_FORMAT)} to ${moment(to).format(TOOLTIP_LABEL_FORMAT)}`;
};

const isCDNIssue = (aiAlertKey, rootCauseWithoutFormatting) => {
  const isCDNIssue = rootCauseWithoutFormatting.includes('CDN');
  const isCDNMetric = ['AUTOALERTVPF', 'AUTOALERTCIRR'].includes(aiAlertKey);
  return isCDNIssue && isCDNMetric;
};

// formatting code is copied from the aiAlertEventDetail component
export const formatAlertSummary = (alert) => {
  const {
    alertId,
    metricDisplayName,
    cumulativeImpactedUniques,
    cumulativeTotalUniques,
    alertEvents,
    peakValue,
    issueStartTime,
    rootCauseWithoutFormatting,
    aiAlertKey,
    status,
    eventTimeRaw,
  } = alert;

  const endTime = alertEvents.length && alertEvents[alertEvents.length - 1].eventTime;
  const peakEvent = alertEvents.find((alertEvent) => alertEvent.peakValue === peakValue);
  const lastEvent = alertEvents.length && alertEvents[alertEvents.length - 1];
  const impactedPercentage = (
    (lastEvent.cumulativeImpactedUniquesRaw / lastEvent.cumulativeTotalUniques) *
    100
  ).toFixed(2);

  let timeEndedText = 'Time issue ended';
  let alertEndedText = 'Ended Alert';

  if (isAppModule) {
    // APP
    if (alert.status === 'Active') {
      timeEndedText = `Time issue became ${alert.peakSeverity}`;
      alertEndedText = 'Active Alert';
    }
  } else {
    // EI AI
    if (alertEvents.length && lastEvent.eventType !== 'Ended') {
      timeEndedText = `Time issue became ${lastEvent.eventType}`;
      alertEndedText = 'Active Alert';
    }
  }

  const info: any = {
    alertId,
    metricDisplayName,
    rootCause: rootCauseWithoutFormatting,
    timeEndedText,
    alertEndedText,
    issueStartTime,
    issueEndTime: endTime,
    timeAlertFired: moment(eventTimeRaw).format(TOOLTIP_LABEL_FORMAT),
  };

  const showAlertStatus = !aiAlertKey.startsWith('AD_');
  if (showAlertStatus) {
    info.status = status;
  }

  const showPeakValue = !isCDNIssue(aiAlertKey, rootCauseWithoutFormatting);
  if (showPeakValue) {
    info.peakValue = `${peakEvent.peakValue} at ${peakEvent.eventType}`;
  }

  // cumulative impacted unique deatils are not available for pcp
  const showImpactedUniquesDetails =
    aiAlertKey !== 'AUTOALERTPCP' && aiAlertKey !== 'APP_ACTIVE_DEVICES';
  if (showImpactedUniquesDetails) {
    info.cumulativeImpactedUniques = cumulativeImpactedUniques;
    info.impactedPercentage = impactedPercentage;
    info.cumulativeTotalUniques = cumulativeTotalUniques;
  }

  return info;
};
